import React, { useEffect } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import FormInput from './FormInput';

function DatosEmpresa(){
    useEffect(() => {
        localStorage.removeItem(process.env.REACT_APP_CODIGO_APROBADO)
    },[]) 
    return(  
        <>  
            <div id="datosEmpresa">
                <div className='row'>
                    <FormInput id={"razonSocial"} text={"Razón social / Nombre de fantasía"} type={"text"} className={"col-md-4 col-12 offset-sm-1 col-sm-10"}/>
                    <FormInput id={"cuit"} text={"CUIT"} type={"number"} className={"col-md-3 col-12 offset-sm-1 col-sm-10 offset-md-0"} helper={"(Sin guiones)"}/>   
                    <FormInput id={"telefono"} text={"Teléfono"} type={"number"} className={"col-md-3 col-12 offset-sm-1 col-sm-10 offset-md-0"}  helper={"(Sin guiones)"}/>
                </div>
                <div className='row'>
                    <FormInput id={"contraseña"} text={"Contraseña"} idSeccion={9} className={"col-md-3 offset-sm-1 col-sm-10"}/>
                    <FormInput id={"confirmarContraseña"} text={"Verifica tu contraseña"} idSeccion={9} className={"col-md-3 offset-sm-1 col-sm-10 offset-md-0"}/>
                    <FormInput id={"uniones"} text={"Unión asociada"} className={"col-md-4 col-12 offset-sm-1 col-sm-10 offset-md-0"} idSeccion={0}/>
                    
                </div>
                <div className='row unificarAltura'>
                    <FormInput id={"descripcionEmpresa"} text={"Descripción de la empresa"} className={"col-md-6 offset-sm-1 col-sm-10 "} idSeccion={1}/>
                    
                    <div className='col-md-4 offset-sm-1 col-sm-10 offset-md-0'>
                        <FormInput id={"email"} text={"Email"} type={"email"} className={""}/>  
                        <FormInput id={"paginaWeb"} text={"Sitio web"} type={"text"} className={""} helper={"(Opcional)"}/>                        
                    </div>
                </div>
                <div className='row'>
                    <label for="exampleInputEmail1" class="offset-sm-1 col-sm-10 col-md col form-label letraDatos">Dirección de la empresa</label>
                </div>
                <div className='row'>
                    <FormInput id={"calle"} type={"text"} className={"col-md-5 offset-sm-1 col-sm-10" } placeholder={"Calle"} idSeccion={2}/> 
                    <FormInput id={"altura"} type={"text"} className={"col-md-5 offset-sm-1 col-sm-10 offset-md-0"} placeholder={"Altura"} idSeccion={2}/> 
                </div>
                <div className='row'>
                    <FormInput id={"localidad"} type={"text"} className={"col-md-5 offset-sm-1 col-sm-10"} placeholder={"Localidad"} isDireccion={true} idSeccion={2}/> 
                    <FormInput id={"codigoPostal"} type={"number"} className={"col-md-5 offset-sm-1 col-sm-10 offset-md-0"} placeholder={"Código Postal"} isDireccion={true} idSeccion={2}/> 
                </div>
            </div>  
        </>
    );
}

export default DatosEmpresa;